import moment from 'moment';

export interface BillingPeriods {
  count: number;
  label: string;
}

export interface BillingRange {
  start: string;
  end: string;
}

type BillingUnit = 'month' | 'year';

export function getBillingPeriods(ranges: Array<BillingRange>, isYearly: boolean): BillingPeriods | null {
  const unit: BillingUnit = isYearly ? 'year' : 'month';
  const uniquePeriods = new Map<number, moment.Moment>();

  ranges.forEach((range) => getRangePeriods(range, unit).forEach((period) => uniquePeriods.set(period.valueOf(), period)));

  if (!uniquePeriods.size) {
    return null;
  }

  const periods = Array.from(uniquePeriods.values()).sort((a, b) => a.valueOf() - b.valueOf());

  return { count: periods.length, label: isYearly ? formatYears(periods) : formatMonths(periods) };
}

function getRangePeriods({ start, end }: BillingRange, unit: BillingUnit): Array<moment.Moment> {
  const moments = [...(start ? [moment.utc(start)] : []), ...(end ? [moment.utc(end).subtract(1, 'second')] : [])];

  if (!moments.length) {
    return [];
  }

  const last = moment.max(moments).clone().startOf(unit);
  const periods: Array<moment.Moment> = [];

  for (const cursor = moment.min(moments).clone().startOf(unit); cursor.isSameOrBefore(last); cursor.add(1, unit)) {
    periods.push(cursor.clone());
  }

  return periods;
}

function formatYears(years: Array<moment.Moment>): string {
  return years.map((year) => year.year()).join(', ');
}

function formatMonths(months: Array<moment.Moment>): string {
  return months.map((month) => month.format('MMMM YYYY')).join(', ');
}
